import React from 'react';

export const CircleIcon = ({
  fill = 'currentColor',
  size = '32',
  stroke = 'none',
  strokeWidth = '0',
  wrapperClass,
  scale = '1',
}: any) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          stroke={stroke}
          cx="12.5"
          cy="12.5"
          r="10"
          fill={fill}
          strokeWidth="10%"
          style={{
            transform: `scale(0.8)`,
          }}
        />
      </svg>
    </span>
  );
};

export default CircleIcon;
